import axios from "axios";
import queryString from 'query-string';
import Joi from 'joi-browser';
import { APIAddress } from "constants/config";

const GENDER = ['male', 'female','other','n/a']

export const schema = Joi.object().keys({
	ssFirstName: Joi.string().required(),
	ssLastName: Joi.string().required(),
	ssNickName: Joi.string().allow(''),
	ssGender: Joi.any().required(),
  ssBirthday: Joi.string().allow('').allow(null),
  ssPhone: Joi.string().allow(''),
  ssHomePhone: Joi.string().allow(''),
  ssEmail: Joi.string().allow(''),
  ssSource: Joi.string().allow(''),
	ssSocialType: Joi.number().allow(null),
  ssSocialID: Joi.string().allow(''),
  ssCountry: Joi.string().allow(''),
  ssProvince: Joi.string().allow(''),
  ssCity: Joi.string().allow(''),
  ssPostcode: Joi.string().allow(''),
  ssAddress: Joi.string().allow(''),
  ssRemark: Joi.string().allow(''),
  ssStudentCreateTime: Joi.string().allow('').allow(null),
  ssSuitNumber: Joi.string().allow(''),
  ssCode: Joi.string().allow(''),
  student_bound: Joi.number().allow(null),
  teacher_bound: Joi.number().allow(null),
  parents_bound: Joi.number().allow(null),
  ssSchool: Joi.string().allow(''),
  ssStudent: Joi.string().allow(''),

  custom_data: Joi.object(),
  photo: Joi.object(),
    
  ssParentsName: Joi.string().allow(''),
  ssGuardianRelation: Joi.string().allow(''),
  ssParentsEmail: Joi.string().allow(''),
  ssParentsPhone: Joi.string().allow(''),

  ssParents2Name: Joi.string().allow(''),
  ssGuardian2Relation: Joi.string().allow(''),
  ssParents2Email: Joi.string().allow(''),
  ssParents2Phone: Joi.string().allow(''),
});

export default function updateStudentInfo(studentId, studentInfo) {

  if(!studentId){
    throw 'missing student ID'
  }
  
  let validateResult = Joi.validate(studentInfo, schema);

  if (validateResult.error) {
    return new Promise((resolve, reject)=> {
      reject(validateResult);
    });
  }

  //
  // when the data is a plain json with no file we use proxy server.
  // when it contains multi-part/form-data we upload it directly
  //
  let toServer = {
    ...studentInfo,
    ssGender: typeof studentInfo.ssGender === 'string' ? GENDER.indexOf(studentInfo.ssGender) : studentInfo.ssGender,
  }

  // only use this for now
  if (toServer.photo) {
    return updateWithUpload(studentId, toServer);
  } else {
    return update(studentId, toServer);
  }

}

function updateWithUpload(studentId, toServer) {

  let API_URL
  if (process.env.APP_ENV == 'development') {
    API_URL = 'https://saas.classtop.com:3001/sapi';
  } else {
    API_URL = 'https://school.classtop.com:3001/sapi';
  }

  return new Promise((resolve, reject) => {
    let data = new FormData();

    _.each(toServer, (value, name)=>{
      if (name === 'photo') {
        data.append('photo', toServer.photo, 'photo');
      } else if (name === 'custom_data') { 
        data.append('custom_data', JSON.stringify(value));
      } else if (typeof value !== 'undefined') {
        data.append(name, value);
      }
    });

    axios.put(API_URL + '/u_stdtinfo/' + studentId + '/', data, {
      'onUploadProgress': (progress)=>{
        if (typeof onUploadProgress == 'function') {
          progress.ratio = progress.loaded / progress.total;
          onUploadProgress(progress);
        }
      },
      headers: {
        'Authorization': 'JWT ' + localStorage.getItem('token'),
        'Content-Type': 'multipart/form-data',
      }
    })
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      reject(err);
      console.error(err)
    });

  });

}

function update(studentId, toServer) {
  
  return new Promise((resolve, reject) => {
    axios.put(APIAddress, {'uri': `/u_stdtinfo/${studentId}/`,
		'method': 'PUT',
		'data': JSON.stringify(toServer),
		'token': localStorage.getItem('token')})
    .then((res) => {
      resolve(res.data);
    })
    .catch((err) => {
      console.error(err);
      reject(err);
    })
  })
}



// WEBPACK FOOTER //
// ./src/controllers/controllers/student/updateStudentInfo.js